import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inhaltstypSelect", "textDescriptionField", "tagHint", "reiseinfoHint", "textFieldLabel"]
  static values = { tagTitelId: Number, reiseinfoTitelId: Number }

  connect() {
    this.toggleTextarea()
  }

  toggleTextarea() {
    const selectedId = parseInt(this.inhaltstypSelectTarget.value)
    const isTagTitel = selectedId === this.tagTitelIdValue
    const isReiseinfoTitel = selectedId === this.reiseinfoTitelIdValue

    this.textDescriptionFieldTarget.style.display = (isTagTitel || isReiseinfoTitel) ? "block" : "none"
    this.tagHintTarget.style.display = isTagTitel ? "block" : "none"
    this.reiseinfoHintTarget.style.display = isReiseinfoTitel ? "block" : "none"
    if (isTagTitel) {
      this.textFieldLabelTarget.textContent = "Tag-Text (Multimarker):"
    } else if (isReiseinfoTitel) {
      this.textFieldLabelTarget.textContent = "Reiseinfo-Text:"
    }
  }
}
